import { checkPassword } from '@/api/login.js';
export default {
  methods: {
    checkPassword(loginName, password) {
      return checkPassword(loginName, password);
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/checkPassword.js